import { Button, makeStyles, shorthands, tokens } from '@fluentui/react-components';
import { AppState } from '../../App';
import LitiumLogo from '../../assets/logo/LitiumLogo.png';
import { UserSettingsMenu } from './UserSettingsMenu';
import { AppGenericRegular, ChatRegular, SettingsRegular } from '@fluentui/react-icons';
import { useAppSelector } from '../../redux/app/hooks';
import { RootState } from '../../redux/app/store';
import { FeatureKeys } from '../../redux/features/app/AppState';

export const useClasses = makeStyles({
    header: {
        alignItems: 'center',
        backgroundColor: tokens.colorBrandForeground2,
        color: tokens.colorNeutralForegroundOnBrand,
        display: 'flex',
        '& h1': {
            paddingLeft: tokens.spacingHorizontalXL,
            display: 'flex',
        },
        height: '64px',
        justifyContent: 'space-between',
        width: '100%',
    },
    cornerItems: {
        display: 'flex',
        ...shorthands.gap(tokens.spacingHorizontalS),
    },
    logo: {
        height: '64px',
        width: 'auto',
        cursor: 'pointer',
    },
});

interface HeaderProps {
    appState: AppState;
    setAppState: (state: AppState) => void;
}

export const LitiumHeader: React.FC<HeaderProps> = ({appState, setAppState}) => {
    const classes = useClasses();
    const {userAdminSettings} = useAppSelector((state: RootState) => state.app);
    const {features} = useAppSelector((state: RootState) => state.app);

    const onAdminButtonClick = () => {
        setAppState(AppState.Admin);
    }

    const onWorkflowButtonClick = () => {
        setAppState(AppState.Workflows);
    }

    const onLitiumLogoClick = () => {
        if (appState >= AppState.Chat) {
            setAppState(AppState.Chat);
        }
    }

    const onChatButtonClick = () => {
        if (appState >= AppState.Chat) {
            setAppState(AppState.Chat);
        }
    }

    return (
        <div className={classes.header}>
            <img src={LitiumLogo} alt="Logo" className={classes.logo} onClick={onLitiumLogoClick}/>
            {appState > AppState.SettingUserInfo && (
                <div className={classes.cornerItems}>
                    <div className={classes.cornerItems}>
                        {(userAdminSettings.isPersonaAdmin || userAdminSettings.isPromptAdmin) && (
                            <Button
                                data-testid="adminButton"
                                style={{color: 'white'}}
                                appearance="transparent"
                                icon={<SettingsRegular color="white"/>}
                                title="Administration"
                                aria-label="Administration"
                                onClick={onAdminButtonClick}
                            >
                                Administration
                            </Button>
                        )}
                        {features[FeatureKeys.Workflows].enabled && (
                            <>
                                <Button
                                    data-testid="chatButton"
                                    style={{color: 'white'}}
                                    appearance="transparent"
                                    icon={<ChatRegular color="white"/>}
                                    title="Chat"
                                    aria-label="Chat"
                                    onClick={onChatButtonClick}
                                >
                                    Chat
                                </Button>
                                <Button
                                    data-testid="workflowButton"
                                    style={{color: 'white'}}
                                    appearance="transparent"
                                    icon={<AppGenericRegular color="white"/>}
                                    title="Workflows"
                                    aria-label="Workflows"
                                    onClick={onWorkflowButtonClick}
                                >
                                    Workflows
                                </Button>
                            </>
                        )}
                        {/* Removed but will need a big clean up to fully remove */}
                        {/* <PluginGallery/> */}
                        <UserSettingsMenu
                            setLoadingState={() => {
                                setAppState(AppState.SigningOut);
                            }}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};
